import { _, $ } from "js/vendor";
import React, { Component } from "reactn";
import { Button, TextField, Link } from "@material-ui/core";
import { BeautifulDialog, DialogContent, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import styled from "styled-components";
import BeautifulLogo from "js/react/components/BeautifulLogo";
import { Gap20, Gap30 } from "../Gap";
import { mountAuth } from "./mountAuth";

import "css/dialogs.scss";

const FormRow = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    font-weight: 600;
    white-space: nowrap;

    &.muted {
        color: #999;
    }

    &.sub-1 {
        font-size: 12px;
    }

    &.sub-2 {
        font-size: 10px;
    }
`;

const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default class EmailSubmitDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            emailError: false,
        };

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ value: "" });
    }

    validateEmail = value => {
        let emailError = false;
        if (!value) {
            emailError = "Required";
        } else if (!regexEmail.test(value)) {
            emailError = "Invalid email";
        }

        return emailError;
    }

    handleChange = event => {
        const value = event.target.value.trim();

        const {
            emailError
        } = this.state;

        // If the email was invalid, revalidate the new value
        if (emailError) {
            const emailError = this.validateEmail(value);
            this.setState({
                value,
                emailError
            });
        } else {
            this.setState({
                value,
            });
        }
    }

    handleKeyDown = event => {
        // Prevent window.keydown events from firing.
        event.stopPropagation();
    }

    handleKeyPress = event => {
        if (event.key == "Enter") {
            this.props.onSuccess && this.props.onSuccess(this.state.value);
            this.props.closeDialog();
        }
    }

    selectTextField = event => {
        // auto select the text field when focused
        event.target.select();
    }

    deselectTextField = event => {
        const {
            value,
        } = this.state;
        const emailError = this.validateEmail(value);
        this.setState({
            emailError
        });
    }

    onSubmit = () => {
        const {
            value
        } = this.state;
        const emailError = this.validateEmail(value);
        if (emailError) {
            this.setState({
                emailError
            });
            return;
        }
        const {
            onSuccess
        } = this.props;
        onSuccess && onSuccess(value);
        this.props.closeDialog();
    }

    onSignIn = () => {
        const {
            onSuccess
        } = this.props;

        mountAuth({
            onSuccess: user => onSuccess && onSuccess(user.email),
            allowClose: !this.props.preventClose,
        });

        this.props.closeDialog();
    }

    render() {
        const {
            emailError
        } = this.state;
        const { value } = this.state;

        return (
            <BeautifulDialog
                maxWidth="xs"
                preventClose={this.props.preventClose}
                closeDialog={this.props.closeDialog}
                zIndex={this.props.zIndex}
            >
                <DialogContent>
                    <Gap30 />
                    <FormRow>
                        <BeautifulLogo noLink darkOnLight />
                    </FormRow>
                    <FormRow>
                        Enter your email to start the presentation
                    </FormRow>
                    <FormRow>
                        <TextField
                            id="dialog-email-submit"
                            onKeyPress={this.handleKeyPress}
                            onKeyDown={this.handleKeyDown}
                            autoFocus={true}
                            onFocus={evt => this.selectTextField(evt)}
                            onBlur={evt => this.deselectTextField(evt)}
                            placeholder="Email"
                            value={value}
                            fullWidth={true}
                            type="email"
                            variant="outlined"
                            helperText={emailError}
                            error={!!emailError}
                            // inputProps={input.inputProps}
                            onChange={this.handleChange}
                        />
                    </FormRow>
                    {
                        // Leave spacing for the error so the layout
                        //   doesn't shift when the error shows/hides.
                        !emailError &&
                        <Gap20 />
                    }
                    <FormRow>
                        <Button
                            type="button"
                            color="primary"
                            variant="contained"
                            onClick={() => this.onSubmit()}
                            disabled={!!emailError || !value}
                            fullWidth
                        >
                            Start Presentation
                        </Button>
                    </FormRow>
                    <FormRow className="muted sub-1">
                        <div>
                            <span>OR, </span>
                            <Link
                                href="#"
                                onClick={() => this.onSignIn()}
                            >
                                SIGN IN
                            </Link>
                        </div>
                    </FormRow>
                    <FormRow className="muted sub-2">
                        <div>
                            <span>By creating an account, you agree to the </span>
                            <Link
                                href="/terms-of-service"
                                target="_blank"
                            >Terms of Service
                            </Link>
                            <span> and </span>
                            <Link
                                href="/privacy-policy"
                                target="_blank"
                            >Privacy Policy
                            </Link>
                        </div>
                    </FormRow>
                </DialogContent>
            </BeautifulDialog>
        );
    }
}
